// src/pages/ConnectWithUs.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const ConnectWithUs = () => {
  return (
    <>
      <Helmet>
        <title>Connect With Us | Ziyarat Guide</title>
        <meta
          name="description"
          content="Get in touch with the Ziyarat Guide team. Reach us for travel guidance, pilgrim support, or shrine information in Karbala and Najaf."
        />
        <meta
          property="og:title"
          content="Connect With Us | Ziyarat Guide"
        />
        <meta
          property="og:description"
          content="Contact the Ziyarat Guide team for inquiries, travel help, and spiritual guidance on your journey to Karbala and Najaf."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/static/media/ZiyaratGuide.png"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="contact-page px-4 py-8">
        <div className="contact-container max-w-6xl mx-auto flex flex-col lg:flex-row gap-8">
          {/* Left side: form */}
          <div className="contact-form flex-1 bg-white shadow-md rounded-lg p-6">
            <h1 className="text-2xl font-bold mb-4">Connect With Us</h1>
            <p className="text-gray-600 mb-6">
              We’d love to hear from you. Drop us a message below.
            </p>
            <form className="flex flex-col gap-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  placeholder="Your full name"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  placeholder="Write your message..."
                  rows="4"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
              </div>

              <button
                type="submit"
                className="bg-blue-600 text-white font-semibold px-4 py-2 rounded-md hover:bg-blue-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Right side: map */}
          <div className="contact-map flex-1 bg-white shadow-md rounded-lg overflow-hidden">
            <iframe
              title="Iraq Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6844429.302826952!2d38.42384761314085!3d33.10891307270137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1557823d54f54a11%3A0x6da561bba2061602!2sIraq!5e0!3m2!1sen!2suk!4v1757178080591!5m2!1sen!2suk"
              className="w-full h-64 lg:h-full"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="contact-info-box p-6">
              <h2 className="text-lg font-semibold mb-2">
                Contact Information
              </h2>
              <p className="text-gray-700">Karbala, Iraq</p>
              <p className="text-gray-700">info@ziyaratguide.com</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectWithUs;
